import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  jobs: [],
  cachedJobs: {},
  categories: [],
  cachedCategories: {},
  job: {},
  cachedJobId: {},
  jobsByCompanyId: [],
  cachedJobCompanyId: {},
  jobsLoading: true,
  jobLoading: true,
  jobsFilters: {},
};

export default {
  actions,
  getters,
  mutations,
  state,
};
